import { FakeBoolean } from '@mygpt/app';

export const convertBooleanType = (defaultValue: boolean, value?: FakeBoolean) => {
  if (!value) return defaultValue;

  return JSON.parse(value.toLowerCase()) as boolean;
};
